import { useFetch } from '@cordata/buffet';
import React from 'react';
import { useParams } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { uniq, compact } from 'lodash';

import { UncontrolledTable } from '~/components';
import { formatDate } from '~/utils';

const Maltreatment = () => {
  const params = useParams();
  const [sourceCanStatus, sourceCan] = useFetch('data/public/list-view-cs-tbl-source-can', { params: { patient_uid: params.patient_id }, initialState: [], instance: 'p' });

  return (
    <div className="mx-4">
      <p className="text-muted">
        <em>
          Total Count of Investigated Child Abuse/Neglect Reports:{' '}
          {sourceCanStatus === 'success' && (sourceCan[0]?.attributes?.totalIntakes || 0)}
        </em>
      </p>

      <p className="text-primary">
        <b>
          {/* TODO get updated copy for this */}
          Detail for Investigated Child Abuse/Neglect Reports with a Finding of
          Substantiated&nbsp;
          <FontAwesomeIcon icon="exclamation-circle" id="substantiated-info" />
          &nbsp;or&nbsp;
          Indicated&nbsp;
          <FontAwesomeIcon icon="exclamation-circle" id="indicated-info" />
          :
        </b>
      </p>

      <UncontrolledTooltip target="substantiated-info">
        An admission of the child abuse or neglect by the person(s)
        responsible or other forms of confirmation deemed valid by the caseworker/PCSA
      </UncontrolledTooltip>

      <UncontrolledTooltip target="indicated-info">
        Circumstantial or other isolated indicators of child abuse or neglect
        but lacking confirmation
      </UncontrolledTooltip>

      <UncontrolledTable
        name="maltreatment"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-source-can',
          params: { patient_uid: params.patient_id },
        }}
        defaultSorted={[{ id: 'intakeReceivedDt' }]}
        pivotBy={['intakeId']}
        columns={[
          {
            id: 'intakeId',
            Header: 'Intake ID',
            accessor: 'attributes.intakeId',
          },
          {
            id: 'intakeReceivedDt',
            Header: 'Intake Date',
            accessor: 'attributes.intakeReceivedDt',
            aggregate: vals => uniq(vals).map(v => formatDate(v)).join(', '),
            cellType: 'date',
          },
          {
            id: 'agencyCounty',
            Header: 'Investigating County',
            accessor: 'attributes.agencyCounty',
            aggregate: vals => uniq(vals).join(', '),
          },
          {
            id: 'allegation',
            Header: 'Allegation',
            accessor: 'attributes.allegation',
            aggregate: vals => uniq(vals).join(', '),
          },
          {
            id: 'disposition',
            Header: 'Findings',
            accessor: 'attributes.disposition',
            // the following is a uat thing that is `from legacy` and we need to observe the same
            // else it'd be a normal uniq(vals) like all the others
            aggregate: vals => uniq(compact(vals).every(v => v.toLowerCase().includes('substantiated')) ? ['Substantiated'] : vals).join(', '),
          },
          {
            id: 'harmDescription',
            Header: 'Harm Description',
            accessor: x => (x.attributes.harmDescription || '').replace('Not Applicable', ''),
            aggregate: vals => compact(uniq(vals)).join(', '),
          },
          {
            id: 'severityOfHarm',
            Header: 'Severity of Harm',
            accessor: x => (x.attributes.severityOfHarm || '').replace('Not Applicable', ''),
            aggregate: vals => compact(uniq(vals)).join(', '),
          },
        ]}
      />

      <p className="mt-3 text-center text-muted">
        <em>
          There may be additional allegations under investigation not displayed.
          This list may not reflect all maltreatment a child has experienced.
        </em>
      </p>
    </div>
  );
};

export default Maltreatment;
